import { topicItems, carouselItems, commentItems } from '@/mocks/home';

export function TopicsSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          大家都在讨论的影视热点，看看有没有你感兴趣的
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <div
              key={item.tag}
              className="group cursor-pointer flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-colors"
            >
              <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{item.tag}
              </span>
              <span className="text-[10px] text-foreground-400 bg-background-200/70 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                {item.heat}热度
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          深度策划的影视专题，发现更多精彩内容
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer group"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    if (t.parentElement) t.parentElement.style.display = 'none';
                  }}
                />
              </div>
              <div className="p-4">
                <span className="inline-block text-[10px] px-2 py-0.5 rounded bg-accent-100 text-accent-700 font-medium mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs font-medium text-foreground-600 mb-2">{item.subtitle}</p>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <i
        key={i}
        className={`text-xs ${i < rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-foreground-300'}`}
      ></i>
    ));
  };

  return (
    <section id="comments" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          用户评价
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          来自真实用户的使用反馈与观影体验分享
        </p>
        <div className="space-y-4">
          {commentItems.map((comment, i) => (
            <div
              key={i}
              className="p-5 rounded-lg bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const t = e.currentTarget;
                      t.style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-foreground-900">{comment.name}</span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {renderStars(comment.rating)}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}